import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiLoader } from '@taiga-ui/core';

import { WaitTelegramChatsComponent } from './wait-telegram-chats.component';

@NgModule({
  declarations: [WaitTelegramChatsComponent],
  imports: [CommonModule, TuiLoader],
  exports: [WaitTelegramChatsComponent],
})
export class WaitTelegramChatsModule {}
